import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SkeletonTable from "../../components/table/SkeletonTable";
import columns from "../../columns/services/column";
import View from "../../assets/View";
import { getAllServiceApi } from "../../api/request/service";
import GlobalTooltip from "../../components/common/GlobalTooltip";

const FileTypes = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleView = (data) => {
    navigate(`/files_report/${data?.id}`, {
      state: { service: data?.name },
    });
  };

  const getServiceList = async () => {
    try {
      setIsLoading(true);
      const { data } = await getAllServiceApi();
      if (data.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              actions: (
                <div onClick={(e) => e.stopPropagation()}>
                  <GlobalTooltip title={"View Service"}>
                    <button onClick={() => handleView(item)}>
                      <View />
                    </button>
                  </GlobalTooltip>
                </div>
              ),
            };
          })
        );
        setTotal(data?.total_record);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getServiceList();
  }, []);

  return (
    <div className="border bg-White rounded-xl pb-5">
      <div className="flex items-center justify-between p-5">
        <h2 className="title">Services {total ? `(${total})` : null}</h2>
      </div>

      <SkeletonTable
        columns={columns}
        data={data}
        isLoading={isLoading}
        onRowClick={(data) => handleView(data)}
      />
    </div>
  );
};

export default FileTypes;
